import { CustomSeriesOptions, customSeriesDefaultOptions } from "lightweight-charts";
import { buyColor } from "../../../../assets/colors";

export interface VolumeCandleSeriesOptions extends CustomSeriesOptions {
    color: string;
    upColor: string;
    downColor: string;
    borderUpColor: string;
    borderDownColor: string;
    wickUpColor: string;
    wickDownColor: string;
    visible: boolean;
    borderVisible: boolean;
    wickVisible: boolean;
}

export const defaultVolumeCandleOptions: VolumeCandleSeriesOptions = {
    ...customSeriesDefaultOptions,
    color: '#000000',
    upColor: buyColor,
    downColor: '#ef5350',
    borderUpColor: buyColor,
    borderDownColor: '#ef5350',
    wickUpColor: buyColor,
    wickDownColor: '#ef5350',
    visible: true,
    borderVisible: false,
    wickVisible: true,
}
